/**
 * 驳回弹框
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './RejectModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Input, Checkbox } from 'antd';
import { OperateType } from '../types';

const layout = {
    labelCol: {
        span: 6
    }
};

const inputValid = [{ required: true, message: '请输入' }];

const InfoModal = (props) => {

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const _handleOk = () => {
        form.validateFields().then(fields => {
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.TaxCommissionRecordMisService.batchHandlerTaxingApply', {
                operateType: OperateType.BASH_OVERRULE,
                taxNumberArray: props.data.rows,
                // material: (fields.material || []).join('/'),
                reason: fields.reason
            }, 'POST').then(() => {
                message.success('操作成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.success(e.message);
                setConfirmLoading(false);
                props.closeMode && props.closeMode();
            });
        });
    }

    function _handleCancel() {
        props.closeMode && props.closeMode();
    }

    return (
        <Modal
            width={550}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form {...layout} className={styles.container} form={form} labelAlign='right'>
                {/* <Form.Item label='需要重新提交材料' name='material'>
                    <Checkbox.Group options={[{ label: '委托书', value: '委托书' }, { label: '身份证', value: '身份证' }]} />
                </Form.Item> */}
                <Form.Item name='reason' label='驳回原因' rules={inputValid}>
                    <Input.TextArea placeholder='请输入' maxLength={300} rows={4} />
                </Form.Item>
            </Form>
        </Modal>
    );

}

InfoModal.propTypes = {
    data: PropTypes.any, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

export default InfoModal;